<template>
  <span v-if="payment.payment_method?.cc_image_url" class="text-secondary text-size-small">
    <img :src="payment.payment_method.cc_image_url" :alt="payment.payment_method.brand" width="32"/> ending in {{ payment.payment_method.last4 }}
  </span>
  <span v-else-if="payment.type == 'ACH'">
    <p class="mb-0">{{ payment.payment_method.bank_name }} <span class="text-secondary text-size-small">ending in {{ payment.payment_method.last4 }}</span></p>
  </span>
  <span v-else>{{ payment.description }}</span>
</template>

<script>
  export default {
    props: {
      payment: Object,
    },
  }
</script>